import Cookies from 'js-cookie';
import { WashdayClient } from 'washday-sdk';
import { cancelSessionRequests, installSessionInterceptors } from './sessionSecurity';

class WashdayClientSingleton {
  private static instance: WashdayClient | null = null;
  private static currentToken: string | null = null;

  /**
   * Get the singleton instance of WashdayClient
   * Automatically refreshes the client if the token has changed
   */
  public static getInstance(): WashdayClient {
    const token = Cookies.get('token') || null;
    
    // If no instance exists or token has changed, create/recreate the client
    if (!this.instance || this.currentToken !== token) {
      if (this.currentToken) cancelSessionRequests(this.currentToken);
      if (this.instance) this.instance.apiToken = null;
      this.currentToken = token;
      this.instance = new WashdayClient(
        this.currentToken, 
        import.meta.env.REACT_APP_WD_SDK_ENV,
        'washday-frontend',
        ''
      );
      installSessionInterceptors(this.instance.axiosInstance);
    }

    return this.instance;
  }

  /**
   * Force refresh the client instance (useful after login/logout)
   */
  public static refresh(options?: { preserveSession?: boolean }): WashdayClient {
    if (this.currentToken && !options?.preserveSession) cancelSessionRequests(this.currentToken);
    if (this.instance) this.instance.apiToken = null;
    this.instance = null;
    this.currentToken = null;
    return this.getInstance();
  }

  /**
   * Clear the singleton instance (useful for logout)
   */
  public static clear(): void {
    if (this.currentToken) cancelSessionRequests(this.currentToken);
    if (this.instance) this.instance.apiToken = null;
    this.instance = null;
    this.currentToken = null;
  }

  /**
   * Get current token being used by the client
   */
  public static getCurrentToken(): string | null {
    return this.currentToken;
  }

  /**
   * Check if client is initialized
   */
  public static isInitialized(): boolean {
    return this.instance !== null;
  }
}

export default WashdayClientSingleton;
